var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import Loading from '@doordash/component-loading';
import { useListTeamAccountOffices } from '../../../hooks/useListTeamAccountOffices';
import { getDefaultTeamAccountOfficeIdFromCookie, setDefaultTeamAccountOfficeIdToCookie, } from './utils/defaultOfficeCookieUtils';
var defaultOfficeContext = {
    offices: [],
    selectedOffice: null,
    isFirstOfficeModalOpen: false,
    setSelectedOfficeId: function () { },
    closeFirstOfficeModal: function () { },
    openFirstOfficeModal: function () { },
    isListLoading: false,
};
var defaultValue = {
    office: defaultOfficeContext,
};
var GroupOrdersCalendarContext = React.createContext(defaultValue);
var GroupOrdersCalendarProvider = function (props) {
    var teamAccountId = props.teamAccountId;
    var _a = __read(React.useState([]), 2), offices = _a[0], setOffices = _a[1];
    // intentionally separated selectedOfficeId and selectedOffice
    // because creating an office only returns an officeId and
    // runs into a lifecycle issue when offices state is not yet updated when create completes
    var _b = __read(React.useState(''), 2), selectedOfficeId = _b[0], setSelectedOfficeId = _b[1];
    var _c = __read(React.useState(null), 2), selectedOffice = _c[0], setSelectedOffice = _c[1];
    var _d = __read(React.useState(true), 2), isFirstOfficeModalOpen = _d[0], setIsFirstOfficeModalOpen = _d[1]; // first office modal should be open unless offices exist
    React.useEffect(function () {
        // ensure get the latest office information when list is reloaded
        if (selectedOfficeId && offices.length > 0) {
            var officeData = offices.find(function (office) { return office.id === selectedOfficeId; });
            setSelectedOffice(officeData);
        }
    }, [selectedOfficeId, offices]);
    var handleSetSelectedOfficeId = function (officeId) {
        // save selected office id to cookie
        setDefaultTeamAccountOfficeIdToCookie(teamAccountId, officeId);
        // React set state for office id
        setSelectedOfficeId(officeId);
    };
    var closeFirstOfficeModal = function () {
        if (isFirstOfficeModalOpen) {
            setIsFirstOfficeModalOpen(false);
        }
    };
    var openFirstOfficeModal = function () {
        if (!isFirstOfficeModalOpen) {
            setIsFirstOfficeModalOpen(true);
        }
    };
    var isListLoading = useListTeamAccountOffices(teamAccountId, {
        onCompleted: function (data) {
            var _a;
            if ((_a = data === null || data === void 0 ? void 0 : data.listTeamAccountOffices) === null || _a === void 0 ? void 0 : _a.offices) {
                var listOffices = data.listTeamAccountOffices.offices;
                if (listOffices.length > 0) {
                    // Has offices
                    setOffices(data.listTeamAccountOffices.offices);
                    if (!selectedOffice) {
                        // check for cookie stored office address
                        var defaultOfficeIdFromCookie_1 = getDefaultTeamAccountOfficeIdFromCookie(teamAccountId);
                        var defaultOfficeFromCookie = defaultOfficeIdFromCookie_1
                            ? listOffices.find(function (office) { return office.id === defaultOfficeIdFromCookie_1; })
                            : null;
                        // initialized selected office to the default from cookie or first office on list
                        setSelectedOffice(defaultOfficeFromCookie || listOffices[0]);
                    }
                    // first office modal not required
                    // affects display so putting it last
                    closeFirstOfficeModal();
                    return;
                }
            }
        },
    }).loading;
    var officeContextValues = {
        offices: offices,
        selectedOffice: selectedOffice,
        isFirstOfficeModalOpen: isFirstOfficeModalOpen,
        setSelectedOfficeId: handleSetSelectedOfficeId,
        closeFirstOfficeModal: closeFirstOfficeModal,
        openFirstOfficeModal: openFirstOfficeModal,
        isListLoading: isListLoading,
    };
    var contextValue = {
        office: officeContextValues,
    };
    return (React.createElement(GroupOrdersCalendarContext.Provider, { value: contextValue }, isListLoading ? (React.createElement(Loading, null)) : (props.children({
        hasSelectedOffice: !!selectedOffice,
        isFirstOfficeModalOpen: isFirstOfficeModalOpen,
        closeFirstOfficeModal: closeFirstOfficeModal,
        openFirstOfficeModal: openFirstOfficeModal,
    }))));
};
var useGroupOrdersCalendarContext = function () {
    var context = React.useContext(GroupOrdersCalendarContext);
    return context;
};
var useOfficeContext = function () {
    var context = React.useContext(GroupOrdersCalendarContext);
    return context.office;
};
export { GroupOrdersCalendarProvider, useGroupOrdersCalendarContext, useOfficeContext, };
